module.exports = __webpack_public_path__ + "img/dp-awards.363e4fe4.jpg";